import { OnDestroy, OnInit, Injectable } from '@angular/core';
import { DomHandler } from 'primeng/dom';
import { LocalizationService } from './localization.service';
@Injectable()
export class BaseComponent implements OnInit, OnDestroy {

  L(name: string, ...params) {
    return LocalizationService.L(name, ...params);
  }
  blockScroll = false;
  ngOnInit() {
    if (this.blockScroll) {
      DomHandler.addClass(DomHandler.findSingle(document.body, '.container'), 'block-scroll')
    }
  }
  ngOnDestroy() {
    if (this.blockScroll) {
      DomHandler.removeClass(DomHandler.findSingle(document.body, '.container'), 'block-scroll')
    }
  }
}
